export function getCorruptedFilesDescription(i18n: any, corruptedFiles: string[], maxFilesDisplayed: number = 3) {
  const error_file = corruptedFiles?.slice(0, maxFilesDisplayed)?.join(', ');
  let description = `${i18n.t('upload-smartphone:upload-corrupted-description-head')} ${error_file}`;
  const counter_file = corruptedFiles.length - maxFilesDisplayed;

  if (counter_file > 0) {
    description += i18n.t('upload-smartphone:upload-corrupted-description-tail-counter', {
      counter_file,
    });
  } else {
    description += i18n.t('upload-smartphone:upload-corrupted-description-tail');
  }
  return description;
}
